// extracted by mini-css-extract-plugin
export default {"sendButton":"estilo_sendButton__4wLl+"};